<template>
  <div class="card" ref="landing-information">
    <h3 class="bold text-primary" style="margin-bottom:6px">{{$t("Information")}}</h3>
    <hr class="text-primary" />
    <div v-if="items.length">
      <div
        v-for="item in items"
        :key="item.id"
        class="information-item"
        @click="selectedItem = item"
      >
        <!-- <md-icon style="margin-right:10px" class="text-primary">{{item.category.icon | icon}}</md-icon>
        <span style="text-decoration:underline;font-weight:500">{{item.category.description.title}}</span>
        <small style="margin-left:10px">({{item.date | moment('YYYY-MM-DD HH:mm')}})</small>-->

        <span class="text-gray regular" style="font-size:18px">
          <md-icon class="text-primary">{{item.category.icon | icon}}</md-icon>
          {{item.category.description.title}}
        </span>
        <!-- <span
          class="text-primary regular"
          style="font-size:12px;margin-left:10px"
        >({{item.date | moment('YYYY-MM-DD HH:mm')}})</span>-->
      </div>
    </div>
    <no-data v-else class="md-layout-item md-size-100" />

    <div class="modal modal-bg" :class="{ show: selectedItem }">
      <modal v-if="selectedItem" @close="selectedItem = null">
        <template slot="header">
          <h3 class="title text-center">
            <md-icon
              style="margin-right:4px"
              class="text-primary"
            >{{selectedItem.category.icon | icon}}</md-icon>
            {{selectedItem.category.description.title}}
          </h3>
          <md-button
            class="md-simple md-close md-just-icon md-round modal-default-button"
            @click="selectedItem = null"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <div v-html="selectedItem.description.content" />
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import axios from "@/util/axios";
import { mapGetters, mapActions } from "vuex";
import { Modal } from "@/components";
import NoData from "@/pages/authenticated/NoData";

export default {
  components: { Modal, NoData },
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current"
    })
  },
  data() {
    return {
      selectedItem: null,
      items: []
    };
  },
  methods: {
    async loadData() {
      this.items = (
        await axios.get("public/conferences/conference/information", {
          params: {
            year: this.conference.year,
            type: this.conference.type,
            language: this.language.code
          }
        })
      ).data;
    }
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    async language() {
      this.items = [];
      await this.loadData();
    }
  }
};
</script>
<style lang="scss" scoped>
.information-item {
  cursor: pointer;
  margin: 0px 0px;
  padding: 7px 0px;
  &:hover {
    box-shadow: 0px 0px 30px #0000000d;
    border-radius: 15px;
    opacity: 1;
  }
}
</style>